<header class="form-header">
  <div class="form-header__content">
    <div class="form-header__left">
      <a class="form-header__logo" [routerLink]="globals.routes()['homepage'].url">
        <app-icon [icon]="'logo'" [height]="32">{{ 'globals.webTitle' | translate }}</app-icon>
      </a>
    </div>
    <div class="form-header__right">
      <app-button class="form-header__phone" [href]="'tel:' + ('globals.contactData.phone' | translate | phone: false : true)" [color]="'light'" [outlined]="true" [outline-width]="'thin'" [size]="'small'" [app-tooltip]="'globals.contactData.phone' | translate" [tooltip-position]="'bottom'">
        {{ 'header.needHelp' | translate }}
      </app-button>
      <a class="form-header__button form-header__button--phone" [href]="'tel:' + ('globals.contactData.phone' | translate | phone: false : true)">
        <app-icon [icon]="'phone'" [width]="24" [height]="24">{{ 'globals.contactData.phone' | translate | phone: true }}</app-icon>
      </a>
      <a class="form-header__button" [routerLink]="carId ? [globals.routes()['detail'].url, makeSlug, modelSlug, carId] : type === 'car-valuation' ? globals.routes()['sellCar'].url : globals.routes()['homepage'].url">
        <app-icon [icon]="'close'" [width]="24" [height]="24">{{ 'globals.close' | translate }}</app-icon>
      </a>
    </div>
  </div>
</header>
